module.exports = __webpack_public_path__ + "static/media/image (14).572edf96.jpg";